import LoanInformation from './LoanInformation';

export default LoanInformation;
